var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.003 13.254h-1.29v-4.54C24.713 3.908 20.805 0 16 0c-4.804 0-8.713 3.909-8.713 8.713v.094h3.109v-.094c0-1.545.628-2.946 1.643-3.96A5.576 5.576 0 0116 3.11h.001a5.61 5.61 0 015.604 5.603v4.54H5.997c-1.019 0-1.845.827-1.845 1.847v15.054c0 1.02.826 1.846 1.846 1.846H26.003c1.019 0 1.845-.826 1.845-1.846V15.1c0-1.019-.826-1.845-1.845-1.845zm-8.154 12.995h-3.698l.662-3.154a2.213 2.213 0 01-1.033-1.87 2.22 2.22 0 014.44 0c0 .788-.414 1.476-1.033 1.87l.662 3.154z"
  })));
}

export default SvgUnlock;